import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
} from '@mui/material';
import {
  CalendarToday as CalendarTodayIcon,
  Person as PersonIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { obtenerFacturasConPosibleCobro } from '../../actions/CobranzasAction';
import { obtenerListaUsuarios } from '../../actions/UsuariosAction';
export default function TPosiblesCobros(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const rows = props.rows;
  const history = useHistory();

  const iraNuevaTarea = (posiblecobro) => {
    let nuevaTareaCobro = [];
    nuevaTareaCobro['cobranza'] = true;
    obtenerListaUsuarios().then((response) => {
      if (response.status === 200) {
        nuevaTareaCobro['DataUsu'] = response.data;
      }
    });
    obtenerFacturasConPosibleCobro(posiblecobro.posiblecobroId).then(
      (response) => {
        if (response.status === 200) {
          nuevaTareaCobro['facturas'] = response.data;
          history.push({ pathname: '/nuevaTarea', state: nuevaTareaCobro });
        } else {
          console.log('ERROR EN TRAER FACTURAS PC');
        }
      }
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PersonIcon sx={{ fontSize: 18 }} />
                  Cliente
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CalendarTodayIcon sx={{ fontSize: 18 }} />
                  Fecha Pactada
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PersonIcon sx={{ fontSize: 18 }} />
                  Generado Por
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <AssignmentIcon sx={{ fontSize: 18 }} />
                  Estado
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <AssignmentIcon sx={{ fontSize: 18 }} />
                  Acciones/Cobrador
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((posiblecobro) => (
                <TableRow
                  key={posiblecobro.posiblecobroId}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    '&:nth-of-type(even)': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <TableCell align="left">
                    <Typography variant="body2" fontWeight={600}>
                      {posiblecobro.cliente}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">
                      {moment(posiblecobro.posiblecobro).format('DD/MM/YYYY')}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">
                      {posiblecobro.usuarioasignado}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    {posiblecobro.cobrador === null ? (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          color: 'error.main',
                        }}
                      >
                        <ErrorIcon sx={{ fontSize: 20 }} />
                        <Typography variant="body2" fontWeight={600}>
                          SIN ASIGNAR
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          color: 'success.main',
                        }}
                      >
                        <CheckCircleIcon sx={{ fontSize: 20 }} />
                        <Typography variant="body2" fontWeight={600}>
                          ASIGNADO
                        </Typography>
                      </Box>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {posiblecobro.cobrador === null ? (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => iraNuevaTarea(posiblecobro)}
                        startIcon={<AssignmentIcon />}
                        sx={{
                          borderRadius: 2,
                          textTransform: 'none',
                          fontWeight: 600,
                        }}
                      >
                        Asignar a Cobrador
                      </Button>
                    ) : (
                      <Typography variant="body2" fontWeight={600}>
                        {posiblecobro.cobrador}
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
      />
    </Box>
  );
}
